module.exports = __webpack_public_path__ + "media/Copy-And-Edit-Report.2e684783.webm";